import React from "react"
import { useOverrides } from "@quarkly/components"
import { Image } from "@quarkly/widgets"

const defaultProps = {
  display: "block",
  height: "30px",
}
const overrides = {}

const Logo = props => {
  useOverrides(props, overrides, defaultProps)

  return (
    <a
      href="/"
      style={{
        textDecoration: "none",
        display: "inline-flex",
        alignItems: "center",
        gap: "12px",
        color: "inherit",
      }}
    >
      {/* ── Wordmark ── */}
      <span
        style={{
          display: "inline-flex",
          alignItems: "baseline",
          gap: "6px",
          color: "inherit",
        }}
      >
        <span
          style={{
            fontFamily: '"Poppins", sans-serif',
            fontWeight: 300,
            fontSize: "24px",
            letterSpacing: "1px",
            color: "inherit",
            lineHeight: 1,
          }}
        >
          atelier
        </span>
        <span
          style={{
            fontFamily: '"Poppins", sans-serif',
            fontWeight: 300,
            fontSize: "24px",
            letterSpacing: "0px",
            color: "inherit",
            lineHeight: 1,
          }}
        >
          α
        </span>
      </span>

      {/* ── Thin separator ── */}
      <span
        style={{
          display: "inline-block",
          width: "1px",
          height: "18px",
          background: "currentColor",
          opacity: 0.2,
        }}
      />

      {/* ── Geometric architectural mark: intersecting planes ── */}
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block", opacity: 0.45 }}
      >
        {/* Outer square — plan view */}
        <rect
          x="0.5"
          y="0.5"
          width="13"
          height="13"
          stroke="currentColor"
          strokeWidth="0.8"
        />
        {/* Inner offset square — section view */}
        <rect
          x="6.5"
          y="6.5"
          width="13"
          height="13"
          stroke="currentColor"
          strokeWidth="0.8"
        />
        {/* Connecting lines — spatial depth */}
        <line
          x1="0.5"
          y1="0.5"
          x2="6.5"
          y2="6.5"
          stroke="currentColor"
          strokeWidth="0.6"
        />
        <line
          x1="13.5"
          y1="0.5"
          x2="19.5"
          y2="6.5"
          stroke="currentColor"
          strokeWidth="0.6"
        />
        <line
          x1="13.5"
          y1="13.5"
          x2="19.5"
          y2="19.5"
          stroke="currentColor"
          strokeWidth="0.6"
        />
        <line
          x1="0.5"
          y1="13.5"
          x2="6.5"
          y2="19.5"
          stroke="currentColor"
          strokeWidth="0.6"
        />
      </svg>
    </a>
  )
}

Object.assign(Logo, { ...Image, defaultProps, overrides })
export default Logo
